import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { BrandList } from '../../../models';
import { HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig } from '../../../config/hotel-tours-list-page.config';
import { EventBusService } from '../../../services/event-bus.service';
import { ToursMapComponent } from '../tours-map.component';

@Component({
  selector: 'app-hotels-map-panel',
  templateUrl: './hotels-map-panel.component.html',
  styleUrls: ['./hotels-map-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ToursMapComponent],
})
export class HotelsMapPanelComponent implements OnInit, OnDestroy {
  isMapAvailable = true;
  isShowMap = false;
  isShowTourLoader = true;
  mapBtnLabel = 'Показать на карте';
  messages: any = {};

  private toggleMapSubscription: Subscription;
  private showToursLoaderSubscription: Subscription;

  constructor(
    private eventBusService: EventBusService,
    private cdRef: ChangeDetectorRef,
    @Inject(HOTEL_TOURS_PAGE_CONFIG) private appConfig: HotelToursPageConfig,
  ) {
    this.isMapAvailable = this.appConfig.brandId !== BrandList.TICKETS_KZ;
    this.isShowMap = !this.isMapAvailable;
    this.messages = this.appConfig.translates.filters;
    this.mapBtnLabel = this.messages.showOnMap;
  }

  ngOnInit(): void {
    this.toggleMapSubscription = this.eventBusService.toggleMap$.subscribe((isMapOpen) => {
      if (!this.isMapAvailable) {
        return;
      }

      this.isShowMap = !isMapOpen;
      this.mapBtnLabel = isMapOpen ? this.messages.closeMap : this.messages.showOnMap;
      this.cdRef.detectChanges();
    });

    this.showToursLoaderSubscription = this.eventBusService.showToursLoader$.subscribe((isShowTourLoader) => {
      this.isShowTourLoader = isShowTourLoader;
      this.cdRef.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.toggleMapSubscription?.unsubscribe();
    this.showToursLoaderSubscription?.unsubscribe();
  }

  toggleMap(): void {
    if (!this.isMapAvailable) {
      return;
    }

    const nextIsMapOpen = this.isShowMap;

    if (nextIsMapOpen) {
      this.eventBusService.trackEventInitMap$.next({
        place: 'desktop.hotels-map-panel.component',
        date: new Date()
      });
    }

    this.eventBusService.toggleMap$.next(nextIsMapOpen);
  }
}
